// extracted by mini-css-extract-plugin
export default {"icon":"Icon_icon__MVwaS","icon__brand":"Icon_icon__brand__doKoc"};